export const contributionFixtures = {
  simpleContribution: [
    {
      eventName: "תרומה לקרן השיוויון",
      childId: 148754,
      eventDate: null,
      eventDescription:
        "קרן השיוויון מסייעת לחניכים שידם אינם משגת להשתתף בפעילות התנועה כשווים, באמצעות תרומתך.",
      eventType: 3,
      startReg: "",
      endReg: "",
      eventId: 34541,
      price: 0,
      priceDate: "2016-08-29 02:24:41",
      priceAfterRase: 0,
      cashOnly: 0,
      eventImageURL:
        "https://harshama-dev-uploads.s3.eu-west-1.amazonaws.com/default1.jpg",
      hasRegularDiscount: false,
      discountPrice: 0,
      discountPayments: 0,
      isRegularDiscount: false,
      isContribution: true,
      isMihlol: false,
      isProduct: false,
      isTax: false,
      isVisible: true,
      regPeriod: 0,
      isRegular: false,
      held: 0,
      note: "קרן השיוויון מסייעת לחניכים שידם אינם משגת להשתתף בפעילות התנועה כשווים, באמצעות תרומתך.",
      externalLink: "http://shivion.noal.org.il/",
      phoneEvent: null,
      phonePaymant: null,
      blockTax: 0,
      allowPurchase: true,
      brotherDiscount: 0,
      isMeshutaf: true,
      nestId: 1609,
      nestCode: "98",
      nestName: "אאא",
      contributionPrice1: 50,
      contributionPrice2: 100,
      contributionPrice3: 200,
      contributionPrice4: 300,
      submittedQuestions: [],
      firstName: "אפיק",
      lastName: "פלג",
      isInCart: false,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/tests/fixtures/contribution.fixtures.ts